import React from "react";
import "./LandingPage.css";
import { Link } from "react-router-dom";
import LandingPageV2 from '../../component/LandingPageV2/LandingPageV2'

export default function LandingPage() {

  return <LandingPageV2/>

  return (
    <div className="landing-container">
      <header className="landing-header">
        <h1>Coding for Kids & Computer Fundamentals</h1>
        <p>Fun & interactive learning experience for children aged 6–14</p>
        <a href="https://forms.gle/QZ2mqXUfVYvYQY1U6" className="enroll-button">Enroll Now</a>
      </header>
      <section className="login-section">
        <p>Already enrolled?</p>
        <Link to="/login" className="login-link">Login here</Link>
    </section>
      <section className="section highlight">
        <h2>Why Teach Kids to Code?</h2>
        <p>
          Coding boosts creativity, logical thinking, and problem-solving. With our kid-friendly courses, your child can build games, apps, and websites while learning important skills for the future!
        </p>
      </section>

      <section className="section courses">
        <div className="course-card">
          <h3>💻 Coding for Kids</h3>
          <p>Learn Scratch, Blockly, and basics of JavaScript by creating fun games and animations.</p>
        </div>
        <div className="course-card">
          <h3>🧠 Computer Fundamentals</h3>
          <p>Explore computer basics, internet safety, typing skills, MS Office, and more in an easy-to-understand format.</p>
        </div>
      </section>

      <section className="section benefits">
        <h2>What Students Get</h2>
        <ul>
          <li>📚 Interactive Lessons</li>
          <li>🎮 Game-based Learning</li>
          <li>👩‍🏫 Experienced Mentors</li>
          <li>🏆 Certificates and Rewards</li>
        </ul>
      </section>

      <footer className="landing-footer">
        <p>&copy; {new Date().getFullYear()} School Shala. All rights reserved.</p>
      </footer>
    </div>
  );
}
